<template>
  <div class="container-fluid device">
    <div class="overlay" v-if="!isLoaded">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
   </div>
   
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{txt('Billing')}} {{txt('Info')}}</h1>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-1">
          <div class="card-header py-3 d-flex flex-row justify-content-between">
            <h6 class="m-0 font-weight-bold text-primary">  <i class="fas fa-print"></i> {{txt('Billing')}}</h6>
              <div>
                <label style="top:-7px;position:relative">{{txt('Date')}} </label>&nbsp;&nbsp;
            <select
              class="browser-default custom-select form-control selectTag"
              v-model="billingDate"
              id="billingDate"
              @change="changeBillingDate"
              style="width:150px"
            >
              <option value disabled>{{txt('Select date')}}</option>
              <option
                v-for="(bDate, index) in billingDates"
                v-bind:value="bDate"
                :key="index"
              >{{bDate}}</option>
            </select>
              </div>
          </div>
        <div class="card-body" style="padding:0;">
          <div class="collapse-group">
            <div class="panel panel-default">
              

              <div class="panel-heading" role="tab" id="headingTotal">
                <h5 class="panel-title">
                  <a role="button" href="#collapseTotal" aria-expanded="true" aria-controls="collapseTotal-NO_TARGET" >
                    <div class="text-left">{{txt('Total')}}</div>
                    <div class="text-right">{{billingInfo.billingTotal | toCurrency}}</div>
                  </a>
                </h5>
              </div>


              <div class="panel-heading" role="tab" id="headingOne" v-if="billingInfo.usageInfo.sms">
                <h5 class="panel-title">
                  <a role="button" data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="trigger">
                    SMS
                  </a>
                </h5>
              </div>
              <div id="collapseOne" class="panel-collapse collapse billing show" role="tabpanel" aria-labelledby="headingOne" >
                <div class="panel-body" v-if="billingInfo.usageInfo.sms">
                   <div class="text-right"><span >{{billingInfo.usageInfo.sms.total | toCurrency}}</span></div>
                    <div class="card mb-3" v-for="(item,index) in billingInfo.usageInfo.sms.items" :key="index">
                         
                          <div class="card-header  d-flex flex-row justify-content-between p-0">
                            {{item.displayName}}
                          </div>
                            <div class="card-body p-0" style="color:#747272">
                              <div class="row">
                              <div class="col-md-7">
                                ${{item.unitPrice}} {{`${(item.unit)?'per '+item.unit:''}`}}{{`${item.deviceId?', Device '+ item.deviceId:''}`}}
                              </div>
                               <div class="col-md-3">
                                 {{item.units}} {{`${(item.units>1)?item.unit+'s':(item.unit)?item.unit:''}`}}
                              </div>
                               <div class="col-md-2 text-right">
                                 {{`${item.total?item.total:'0'}` | toCurrency}}
                              </div>
                              </div>
  
                            </div>
                    </div>
                  
                </div>
              </div>

              <div class="panel-heading" role="tab" id="headingOne" v-if="billingInfo.usageInfo.email">
                <h5 class="panel-title">
                  <a role="button" data-toggle="collapse" href="#collapseOne" aria-expanded="true" aria-controls="collapseOne" class="trigger">
                    Email
                  </a>
                </h5>
              </div>
              <div id="collapseOne" class="panel-collapse collapse billing show" role="tabpanel" aria-labelledby="headingOne" >
                <div class="panel-body" v-if="billingInfo.usageInfo.email">
                   <div class="text-right"><span >{{billingInfo.usageInfo.email.total | toCurrency}}</span></div>
                    <div class="card mb-3" v-for="(item,index) in billingInfo.usageInfo.email.items" :key="index">
                         
                          <div class="card-header  d-flex flex-row justify-content-between p-0">
                            {{item.displayName}}
                          </div>
                            <div class="card-body p-0" style="color:#747272">
                              <div class="row">
                              <div class="col-md-7">
                                ${{item.unitPrice}} {{`${(item.unit)?'per '+item.unit:''}`}}{{`${item.deviceId?', Device '+ item.deviceId:''}`}}
                              </div>
                               <div class="col-md-3">
                                 {{item.units}} {{`${(item.units>1)?item.unit+'s':(item.unit)?item.unit:''}`}}
                              </div>
                               <div class="col-md-2 text-right">
                                 {{`${item.total?item.total:'0'}` | toCurrency}}
                              </div>
                              </div>
  
                            </div>
                    </div>
                  
                </div>
              </div>


              <div class="panel-heading" role="tab" id="headingTwo" v-if="billingInfo.usageInfo.whatsapp">
                <h5 class="panel-title">
                  <a role="button" data-toggle="collapse" href="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo" class="trigger">
                    Whatsapp
                  </a>
                </h5>
              </div>
              <div id="collapseTwo" class="panel-collapse collapse billing show" role="tabpanel" aria-labelledby="headingTwo" >
                <div class="panel-body" v-if="billingInfo.usageInfo.whatsapp">
                   <div class="text-right"><span >{{billingInfo.usageInfo.whatsapp.total | toCurrency}}</span></div>
                    <div class="card mb-3" v-for="(item,index) in billingInfo.usageInfo.whatsapp.items" :key="index">
                         
                          <div class="card-header  d-flex flex-row justify-content-between p-0">
                            {{item.displayName}}
                          </div>
                            <div class="card-body p-0" style="color:#747272">
                              <div class="row">
                              <div class="col-md-7">
                                ${{item.unitPrice}} {{`${(item.unit)?'per '+item.unit:''}`}}{{`${item.deviceId?', Device '+ item.deviceId:''}`}}
                              </div>
                               <div class="col-md-3">
                                 {{item.units}} {{`${(item.units>1)?item.unit+'s':(item.unit)?item.unit:''}`}}
                              </div>
                               <div class="col-md-2 text-right">
                                 {{`${item.total?item.total:'0'}` | toCurrency}}
                              </div>
                              </div>
  
                            </div>
                    </div>
                  
                </div>
              </div>


            </div>
          </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import toast from '../services/toast';
import store from '../store/store';
import _ from 'lodash';

export default {
  name: "Billing",
  // created(){
  //   this.isLoaded = true
  //   console.log('created billing')
  // },
  async mounted(a, b, c){
    console.log('mounted billing', {a, b, c, isLoaded: this.isLoaded})
    this.billingDates = await this.getBillingDates()
    this.billingDate = _.first(this.billingDates)
    this.billingInfo = await this.getBillingInfo(this.billingDate)
    this.isLoaded = true
  },
  // beforeRouteEnter: async function(to, from, next) {
  //   next(vm => {
  //     const app = vm;
  //     vm.getBillingDates();
  //   });
  // },
  data: function() {
    return {
      billingInfo: {
        usageInfo: {},
      },
      billingDate: '',
      billingDates: '',
      billingDate: '',
      isLoaded: false,
      billingTotal: 0,
    };
  },
  methods: {
   getBillingInfo(customDate){
    //  console.log('getBillingInfo')
      const app = this;
      // app.isLoaded = true;

      return this.axios
        .get(`/account/${store.getters.accountID}/billing?date=${customDate}`)
        .then(response => {
          let billingInfo = response.data; 
          billingInfo.billingTotal = _(billingInfo.usageInfo).map(v => v.total).sum()
          return billingInfo

          // return response.data
        })
        .catch(function(error) {
           toast.error(error.response.data.message)
        });
   },
   getBillingDates(){
      const app = this;
      return this.axios
        .get(`/account/${store.getters.accountID}/billingDates`)
        .then(async response => {
          return response.data.dates
            //  app.billingDates = response.data.dates; 
            //  if(app.billingDates.length>0)
            //  {
            //    app.billingDate = response.data.dates[0];
            //    let billingInfo = await app.getBillingInfo(app.billingDate);
            //    app.billingTotal = _(billingInfo.usageInfo).map(v => v.total).sum()
            //  }
        })
        .catch(function(error) {
           toast.error(error.message)
        });
   },
   async changeBillingDate(){
    this.isLoaded = false
    this.billingInfo = await this.getBillingInfo(this.billingDate);
    this.isLoaded = true
   }
  
  }
};
</script>

<style scoped>

.collapse-group {
  padding: 30px;

}
#collapseOne{
  font-size: 18px;
}
.panel-title .trigger:before {
	content: "\25bc";
  font-family: 'Glyphicons Halflings';
  vertical-align: text-bottom;
}

.panel-title .trigger.collapsed:before {
  content: '\25BA';
}
h5 a{
  text-decoration: none;
}
div.billing .card{
 border: none;
 padding-left: 25px;
}
div.billing .card-header{
   border-bottom: 2px solid #e3e6f0;
   background:#ffff;
}
#billingDate:before{
  content: 'Date';
}
.overlay {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: fixed;
    background: #222222a1;
    z-index: 99;
}

.overlay__inner {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    position: absolute;
}

.overlay__content {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
}

.spinner {
    width: 75px;
    height: 75px;
    display: inline-block;
    border-width: 2px;
    border-color: rgba(255, 255, 255, 0.05);
    border-top-color: #fff;
    animation: spin 1s infinite linear;
    border-radius: 100%;
    border-style: solid;
}

@keyframes spin {
  100% {
    transform: rotate(360deg);
  }
}
</style>